import { ReactNode } from 'react';
import { RouteComponentProps } from "react-router-dom";
import { MainStoreType } from './store';
import { headerTenantStoreType } from './navigation/widgets/Tenantdrop/types';


// 1.混合菜单模式 （常规横向） layout:h
// 2.纵向导航纵向菜单（常规纵向） layout:v
// 3.纵向导航极简菜单  layout:vSimple
// 4.横向导航悬浮菜单 layout:hSuspend
// 5.横纵混合菜单 layout:mixed
export type LayoutModes = "h" | "v" | "vSimple" | 'hSuspend' | 'mixed';

export interface getMenuSettingParams {
  module?: string;
  type?: string;
  url?: string;
}

export interface saveMenuSettingParams {
  module?: string;
  // menus?: {
  //   type: number;
  //   target: string;
  // };
  url?: string;
  leftMenus?: settingListType[];
}

export interface settingListType {
  // key: string;
  // content: string;
  // isShow: boolean;
  open?: boolean;
  id?: string;
  module?: string;
  name?: string;
  status?: boolean;
  targetId?: string;
  type?: string;

}

export type HeaderDialogNames =
  | "tenantDialog"
  | "clientDialog"
  | "recommendDialog"
  | "cookieDialog"
  | "appConfigDialog"
  | "createDialog"
  | "feedBackDialog"
  | "demandDialog"
  | "appBuilderDialog"
  | "appNoMenuBuilderDialog"
  | "wxworkIntroDialog"
  | "payTipDialog"
  | "bindMobileDialog"
  | "inviteDialog"
  | "customDialog"
  | "licenseRemindDialog";

export interface DialogsVisibleType {
  tenantDialog?: boolean;
  clientDialog?: boolean;
  recommendDialog?: boolean;
  cookieDialog?: boolean;
  appConfigDialog?: boolean;
  inviteDialog?: boolean;
  createDialog?: boolean;
  feedBackDialog?: boolean;
  appBuilderDialog?: boolean;
  appNoMenuBuilderDialog?: boolean;
  demandDialog?: boolean;
  wxworkIntroDialog?: boolean;
  payTipDialog?: boolean;
  bindMobileDialog?: boolean;
  customDialog?: boolean;
  licenseRemindDialog?: boolean;
}

export interface DialogsStateType {
  visible?: DialogsVisibleType;
  pswVisible?: boolean
}

export interface MainRouteProps extends RouteComponentProps {
  mainStore?: MainStoreType;
  beforeUpdateAsideMenus?: any;
  beforeUpdateFastCreateMenus: any;
  beforeUpdateAppAllMenus: any;
  beforeUpdateAppMenus: any;
  beforeUpdateQuickMenus: any;
  isSpPage?: Boolean;
}

export interface MainProps {
  mainStore?: MainStoreType;
  headerTenantStore?: headerTenantStoreType;
  isSpPage?: Boolean;
}

export interface MainLayoutProps extends RouteComponentProps {
  mainStore?: MainStoreType;
  navigation?: ReactNode;
  aside?: ReactNode;
  moduleContent?: ReactNode;
}

export interface DefaultLoadThemeComProps extends RouteComponentProps {
  mainStore?: MainStoreType;
}

//菜单类型
export enum ModuleType {
  DEFAULT_MENU = "1", //系统默认
  CUSTOM_MENU = "0",  //自定义
}

export class PcThemePluginData {
  id: string = "";
  sysDef: ModuleType = ModuleType.CUSTOM_MENU
  pluginStatus: boolean = false;
  pluginOrder: string = "-1";

  pluginModule: string = ""; //模块
  repName: string = ""; //仓库名
  compName: string = ""; //组件名
  pluginDescribe: string = ""; //描述
}

//自定义弹窗参数
export class CustomDialogParams {
  src: string = "";
  icon: string = "";
  title: string = "";
  width: string = "850";
  height: string = "450";
}

export interface SsoCheckParams {
  targetEmployeeId: string;
  targetTenantKey: string;
  eteamsid: string;
}
export interface SsoChangeParams {
  changeInfo: string;
  service: string
}
export interface ChangeTenantParams {
  employeeId: string;
  tenantKey: string;
}

//客户端主题导航显示方式
export enum ClientNavType {
  HORIZONTAL, //横向
  VERTICAL, //纵向
  MIXED  //混合
}
//快捷搜索显示方式
export enum SearchShowType {
  FLOAT = '0', //悬浮显示
  EXPAND = '1'  //平铺显示
}

//快捷搜索位置
export enum SearchLocation {
  LEFT = '0',
  CENTER = '1',
  RIGHT = '2'
}

//主题风格
export type topicStyleType = 'dark' | 'light' | 'client'

export const clientTypeLayoutModeMap = {
  [ClientNavType.HORIZONTAL]: "h",
  [ClientNavType.VERTICAL]: "v",
  [ClientNavType.MIXED]: "mixed"
}

export const searchLocationMap = {
  [SearchLocation.RIGHT]: "right",
  [SearchLocation.CENTER]: "none",
  [SearchLocation.LEFT]: "left"
}